<template>
  <div class="video-banner">
    <div class="title font-34 light uppercase">
      {{ _.get(contentData, "data.list[0].title") }}
    </div>
    <div class="container pointer">
      <video
        @click="play = !play"
        @ended="onEnd()"
        ref="video"
        v-if="_.get(contentData, 'data.list.0.video.videoFile.url')"
        playsinline
        preload="auto"
        type="video/mp4"
        autoplay
        muted
        loop
        :src="
          `${_.get(contentData, 'data.list.0.video.videoFile.url')}#t=0.001`
        "
      ></video>
      <!-- <picture>
        <source
          media="(max-width: 767px)"
          :srcset="_.get(contentData, 'data.list[0].image[0].devices.desktop')"
        />
        <source
          media="(max-width: 1023px)"
          :srcset="_.get(contentData, 'data.list[0].image[0].devices.tablet')"
        />
        <img
          v-if="_.get(contentData, 'data.list[0].image[0].devices.desktop')"
          :src="_.get(contentData, 'data.list[0].image[0].devices.desktop')"
          loading="lazy"
          alt
        />
      </picture> -->

      <!-- <div class="play pointer" @click="play = !play" :class="{ show: !play }">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="38"
          viewBox="0 0 33 38"
        >
          <path
            id="Polygon_1"
            data-name="Polygon 1"
            d="M14.667,7.526a5,5,0,0,1,8.666,0L33.685,25.505A5,5,0,0,1,29.352,33H8.648a5,5,0,0,1-4.333-7.495Z"
            transform="translate(33) rotate(90)"
            fill="#fff"
          />
        </svg>
      </div> -->
    </div>
    <div class="dark-layer"></div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  data() {
    return {
      play: false
    };
  },
  watch: {
    play(val) {
      if (val) {
        setTimeout(() => {
          this.$refs?.video?.play();
        }, 400);
      } else {
        this.$refs?.video?.pause();
      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.play = true;
    }, 400);
  }
};
</script>

<style lang="scss">
.video-banner {
  padding: 144px 0;
  position: relative;
  .dark-layer {
    background: $dirtywhite;
    width: 100%;
    height: 50%;
    max-height: 287px;
    position: absolute;
    bottom: 0;
    z-index: -1;
    @media (max-width: 767px) {
      height: 30%;
    }
  }
  @media (max-width: 1355px) {
    padding: 89px 0;
  }
  @media (max-width: 767px) {
    padding: 34px 0 55px;
  }
  .title {
    padding-bottom: 55px;
    text-align: center;
    max-width: 530px;
    margin: auto;
    @media (max-width: 767px) {
      padding-bottom: 34px;
      font-size: 21px;
    }
  }
  .container {
    width: 100%;
    height: 610px;
    position: relative;
    z-index: 9;
    @media (max-width: 1599px) {
      height: 449px;
    }
    @media (max-width: 1365px) {
      height: 384px;
    }
    @media (max-width: 1125px) {
      margin-left: 0;
      width: calc(100% - 106px);
    }
    @media (max-width: 1023px) {
      height: 282px;
      margin-left: 0;
      width: calc(100% - 90px);
    }
    @media (max-width: 767px) {
      height: 160px;
      width: 100%;
    }
    img,
    video {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
      @media (max-width: 767px) {
        width: calc(100% - 30px);
      }
    }
    .play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 78px;
      height: 78px;
      border: 5px solid #ffc900;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0;
      visibility: hidden;
      transition: 0.4s ease;
      @media (max-width: 767px) {
        width: 40px;
        height: 40px;
      }
      svg {
        margin-left: 5px;
        @media (max-width: 767px) {
          height: 19px;
        }
      }
      &.show {
        opacity: 1;
        visibility: visible;
      }
    }
  }
}
</style>
